<template>
  <!-- container -->
  <div class="o-form-page">
    <o-working-overlay :working="working"></o-working-overlay>
    <!-- :title="title" @click="enableDebug($event)" :level="0" -->
    <o-section>
      <item-form2
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
      ></item-form2>
    </o-section>

    <o-action-buttons
      :item="item"
      :form-state="formState"
      :create="create"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    ></o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../../vue-ocom/mixins";
import ItemForm2 from "../components/ItemForm2.vue";
import OActionButtons from "../../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../../vue-ocom/components/OWorkingOverlay";
import _ from "lodash";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("Process", "process"),
    CreateGroupPermissionMixin("Process"),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm2,
  },
  methods: {
    OnBeforeSave(item) {
      var userRolesByID = _.keyBy(item.roles, "id");

      function CleanUp(items, map) {
        // Remove any values in `items` where its not in the `map`
        var results = [];

        _.forEach(items, function (i) {
          if (i in map) {
            results.push(i);
          }
        });

        return results;
      }
      _.forEach(item.states, function (state) {
        var triggersByID = _.keyBy(state.triggers, "id");

        _.forEach(state.triggers, function (trigger) {
          trigger.roles = CleanUp(trigger.roles, userRolesByID);
        });
        _.forEach(state.transitions, function (trans) {
          trans.triggers = CleanUp(trans.triggers, triggersByID);
        });
      });

      return item;
    },
  },
  computed: {
    title() {
      if (this.create) {
        return "Create Process";
      }

      return "Edit Process";
    },
  },
};
</script>
